var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableBodyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.4085,
    height: 29,
    rx: 5,
    fill: "#43AC43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H20V10.5H10V9ZM10 13H20V14.5H10V13ZM10 17H17V18.5H10V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBodyIcon);
export default __webpack_public_path__ + "static/media/table-body-icon.a7d33d84813a828e2f42a43e8f2405ca.svg";
export { ForwardRef as ReactComponent };